import { GroupbyFlowSecAdapter } from "./groupby.flowsec.adapter";
import { UserAdapterMapper } from "./mapper/user.adapter.mapper";

export class GroupbyUserAdapter extends GroupbyFlowSecAdapter {
  constructor(config) {
    super(config);
  }

  populateIncoming() {
    UserAdapterMapper.populateIncoming(this.keywordsToIncoming);
  }

  populateOutgoing() {
    UserAdapterMapper.populateOutgoing(this.keywordsToOutgoing);
  }
}
